import { Redirect, useRouter } from 'react-resource-router';

export const NotFound = () => {
	const [routeState] = useRouter();

	if (routeState.match.path === '/') {
		return <Redirect to="/" />;
	}

	return <div>Not Found</div>;
};
